import { WorkforcePlanSolicitationDetailsModel } from "services/models/workforceplan/workforceplan-solicitation-details.model";

export type ErpApprovalFieldVisibilityParams = {
	solicitationDetails?: WorkforcePlanSolicitationDetailsModel;
	canExecute: boolean;
	canManageEmploymentContractInformation: boolean;
	canEditJobTitleApprovalFields: boolean;
	payload?: Record<string, unknown>;
};

export function canEditErpIntegrationFields(params: ErpApprovalFieldVisibilityParams): boolean {
	return !!(params.solicitationDetails?.hasErpIntegrationAction() && params.canExecute);
}

export function canShowExecutionDate(params: ErpApprovalFieldVisibilityParams): boolean {
	if (params.canEditJobTitleApprovalFields) {
		return true;
	}

	return !!(params.payload?.executionDate && params.canManageEmploymentContractInformation);
}

export function canShowTradeUnionField(params: ErpApprovalFieldVisibilityParams): boolean {
	if (params.canEditJobTitleApprovalFields) {
		return true;
	}

	return !!(params.payload?.tradeUnionId && params.canManageEmploymentContractInformation);
}

export function buildErpApprovalFieldVisibilityParams(
	solicitationDetails: WorkforcePlanSolicitationDetailsModel | undefined,
	canExecute: boolean,
	canManageEmploymentContractInformation: boolean,
	canEditJobTitleApprovalFields: boolean
): ErpApprovalFieldVisibilityParams {
	return {
		solicitationDetails,
		canExecute,
		canManageEmploymentContractInformation,
		canEditJobTitleApprovalFields,
		payload: solicitationDetails?.payloadData,
	};
}
